'use client';

import IComponentProps from '@/interfaces/componentProps';

export const PageHeading = ({ className = '', children }: IComponentProps) => {
  return <h1 className={`page-heading font-medium transition-all max-sm:text-3xl ${className}`}>{children}</h1>;
};
